 
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import app from './app-dux/app-dux';
import company from './app-dux/company-dux';
import giftCode from './app-dux/gift-code-dux';
import products from './app-dux/products-dux';
import contact from './app-dux/contact-us-dux';
/*******************************************************************************
 *  Gather all the reducers
 */
const reducer = combineReducers( {
    app,
    company,
    giftCode,
    products,
    contact
} );

const middleware = [ thunk ];
middleware.push( createLogger( {
    collapsed: true
} ) );

if ( window.location.port === '5000' ) {
    middleware.push( createLogger( {
        collapsed: true
    } ) );
}

const AppStore = createStore(
    reducer,
    applyMiddleware( ...middleware )
);
export default AppStore;